import { styled } from '@mui/material';

export const sxStyles = {
  subtitle: {
    padding: '2rem 0.5rem 1.5rem 0.5rem',
    textAlign: 'center',
  },
  checkBoxesWrap: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '1.25rem',
  },
  checkBox: {
    display: 'flex',
    alignItems: 'start',
  },
  checkBoxTitle: {
    marginTop: '0.563rem',
  },
};

export const StyledWrap = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '432px',
  width: '100%',
  margin: '0 auto',
}));
